

// -------- Development extension index ---------
//      ! THIS FILE WAS AUTO-GENERATED !
//
// You can overwrite it and have fun, to restore
// the default state: 'npm run compile'

import Main from '../../src/extensions/grid-resize/main.js'
Main.__name__ = 'grid-resize'

const widgets = {  }
const components = {  }
const overlays = {  }
const colorpacks = {  }
const skins = {  }

const Pack = {
    widgets,
    components,
    overlays,
    colorpacks,
    skins,
    Main
}

export default Pack

export {
    widgets,
    components,
    overlays,
    colorpacks,
    skins,
    Main
}